import { render, staticRenderFns } from "./AddtrafficGroupRule.vue?vue&type=template&id=69892d43&scoped=true"
import script from "./AddtrafficGroupRule.vue?vue&type=script&lang=js"
export * from "./AddtrafficGroupRule.vue?vue&type=script&lang=js"
import style0 from "./AddtrafficGroupRule.vue?vue&type=style&index=0&id=69892d43&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69892d43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69892d43')) {
      api.createRecord('69892d43', component.options)
    } else {
      api.reload('69892d43', component.options)
    }
    module.hot.accept("./AddtrafficGroupRule.vue?vue&type=template&id=69892d43&scoped=true", function () {
      api.rerender('69892d43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/productAppConfig/productConfig/trafficGroupRule/components/AddtrafficGroupRule.vue"
export default component.exports